import React from 'react'
import { HiArrowRight } from "react-icons/hi";

const Card = ({ item: { title, des, icon } }) => {
  return (
    <div
      style={{
        background: "#13151a",
        border: "1px solid #1e2228",
        borderRadius: "12px",
        padding: "28px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        transition: "all 0.35s ease",
        cursor: "default",
        position: "relative",
        overflow: "hidden",
      }}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = "#ff014f44";
        e.currentTarget.style.background = "#16181f";
        e.currentTarget.style.transform = "translateY(-4px)";
        e.currentTarget.style.boxShadow = "0 20px 60px #ff014f10";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "#1e2228";
        e.currentTarget.style.background = "#13151a";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Top accent line on hover */}
      <div style={{
        position: "absolute",
        top: 0, left: 0, right: 0,
        height: "2px",
        background: "linear-gradient(90deg, #ff014f, transparent)",
        opacity: 0,
        transition: "opacity 0.35s ease",
      }} className="card-accent" />

      {/* Icon */}
      <div style={{
        width: "44px",
        height: "44px",
        borderRadius: "10px",
        background: "#ff014f15",
        border: "1px solid #ff014f33",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
        color: "#ff014f",
      }}>
        {icon || <HiArrowRight />}
      </div>

      {/* Content */}
      <div style={{ display: "flex", flexDirection: "column", gap: "10px", flex: 1 }}>
        <h2 style={{
          fontFamily: "'Syne', sans-serif",
          fontSize: "17px",
          fontWeight: 700,
          color: "#f0f2f5",
          letterSpacing: "-0.01em",
        }}>
          {title}
        </h2>
        <p style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: "13.5px",
          lineHeight: 1.75,
          color: "#8892a4",
        }}>
          {des}
        </p>
      </div>

      {/* Arrow */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: "11px",
        color: "#ff014f",
        letterSpacing: "0.05em",
      }}>
        <span>view_more</span>
        <HiArrowRight />
      </div>
    </div>
  );
}

export default Card;